import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { cn } from "@/lib/utils";

const NOTES = {
  signup: {
    title: "Your privacy",
    points: [
      "We only ask for your email and a password.",
      "What you type is sent to AI services only to answer you.",
      "You can download or delete everything at any time.",
    ],
  },
  upload: {
    title: "About your files",
    points: [
      "Files are private to your account.",
      "They are read by AI only to do what you asked.",
      "Don't upload passwords, ID numbers or other people's private data.",
    ],
  },
} as const;

/** Short, plain privacy and responsible-AI note shown near sign-up and uploads. */
export const PrivacyNote = ({ kind, className }: { kind: keyof typeof NOTES; className?: string }) => {
  const note = NOTES[kind];
  return (
    <aside aria-label={note.title} className={cn("rounded-lg border border-border bg-muted/30 p-3 text-xs text-muted-foreground", className)}>
      <p className="mb-1 flex items-center gap-1.5 font-medium text-foreground">
        <ShieldCheck className="h-3.5 w-3.5 text-primary" aria-hidden="true" /> {note.title}
      </p>
      <ul className="list-disc space-y-0.5 pl-5">
        {note.points.map((p) => <li key={p}>{p}</li>)}
      </ul>
      <p className="mt-1.5">
        <Link to="/legal/privacy" className="focus-ring text-primary underline-offset-4 hover:underline">Privacy Policy</Link>
        {" · "}
        <Link to="/help" className="focus-ring text-primary underline-offset-4 hover:underline">Help</Link>
      </p>
    </aside>
  );
};
